import { render, staticRenderFns } from "./attendanceClassEdit.vue?vue&type=template&id=ee865368&scoped=true"
import script from "./attendanceClassEdit.vue?vue&type=script&lang=js"
export * from "./attendanceClassEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee865368",
  null
  
)

export default component.exports